module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t('static.clients.index.exportData')))]), _vm._v(" "), [_c('div', {
    staticClass: "flex",
    staticStyle: {
      "flex-direction": "column"
    }
  }, [_c('el-button', {
    staticClass: "margin-b-20",
    staticStyle: {
      "width": "380px"
    },
    on: {
      "click": _vm.downloadAllClients
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('static.clients.index.downloadAllClients')) + "\n        ")])], 1)]], 2), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t('static.clients.index.importData')))]), _vm._v(" "), [_c('div', {
    staticClass: "flex",
    staticStyle: {
      "justify-content": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('file-pond', {
    ref: "pond",
    attrs: {
      "name": " import_excel",
      "label-idle": _vm.$t('static.clients.index.importClients'),
      "allow-multiple": "false",
      "server": _vm.server
    }
  })], 1)])]], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d16ff2c6","hasScoped":false}!./src/app/components/clientImportExportPopup/clientImportExportPopup.html
// module id = 3125
// module chunks = 1